import { defineMessage } from 'services/localization';

export const messages = {
    everyYear: defineMessage('every_year'),
    everyYearsStartingIn: defineMessage('b_n_b_years_starting_in_b_year_b'),
    specificYear: defineMessage('specific_years'),
    everyYearBetween: defineMessage('b_year_b_and_b_year_b'),
    every: defineMessage('every'),
    yearBetween: defineMessage('every_year_between'),
    and: defineMessage('and'),
    startingYear: defineMessage('years_starting_in'),
    includeYears: defineMessage('include_years'),
    excludeYears: defineMessage('exclude_following_years'),
    to: defineMessage('to'),
    yearScheduler: defineMessage('year_scheduler'),
};
